module.exports = __webpack_public_path__ + "static/media/search-pdf.65b3d61b.svg";